import { Location } from '@angular/common';
import { Directive } from '@angular/core';
import { HashStorageService } from '@df/browser/storage/hash-storage.service';
import { ProductComponentDef } from '@df/catalog-ui/product/product.component.def';
import { IModelDataV3WithUrl, Model } from '@df/catalog/model';
import { IProductDataV3, Product } from '@df/catalog/product/product';
import { Meta } from '@df/core/meta/meta';
import { NgInject } from '@df/ng/ng-inject';
import { ActivatedRoute } from '@angular/router';
export const PRODUCT_VIEW_MODEL_CHANGE_EVENT_NAME = 'productView.modelChange';

@Directive()
// tslint:disable-next-line: directive-class-suffix
export class ProductViewComponentDef<T extends Product<IProductDataV3> = Product<IProductDataV3>> extends ProductComponentDef<T> {
    override verbosity = 3;

    @NgInject(Meta)
    private meta!: Meta;

    @NgInject(Location)
    private location!: Location;

    @NgInject(HashStorageService)
    private hashStorageService!: HashStorageService;

    @NgInject(ActivatedRoute)
    private activatedRoute!: ActivatedRoute;

    private urlModel?: T;

    protected allowSimpleProductUrl = false;

    /**
     * Update meta on model change
     */
    protected override onModelChange(): void {
        if (!this.urlModel) {
            this.urlModel = this.model;
        }
        this.meta.model = <Model<IModelDataV3WithUrl>>this.model;
        this.setUrlModel(this.model!);
        super.onModelChange();
        this.app.events.broadcast(PRODUCT_VIEW_MODEL_CHANGE_EVENT_NAME, this.model);
    }

    private setUrlModel(model: T) {
        if (!model) {
            console.warn('NO MODEL', this.model, model);
        }
        const urlModel = this.allowSimpleProductUrl ? model : (model?.parent as T);

        if (this.urlModel !== urlModel && urlModel.data) {
            this.urlModel = urlModel;
            const fragment = this.hashStorageService.getHash();
            const existingSearch = this.activatedRoute.snapshot.queryParams;
            const existingSearchParams = existingSearch ? new URLSearchParams(existingSearch).toString() : '';
            const url =
                urlModel.data!.url +
                (existingSearchParams ? '?' + existingSearchParams : '') +
                (fragment?.length > 3 ? '#' + fragment : '');
            this.location.replaceState(url);
        }
    }

    override get price(): number {
        return this.model!.getPrice({ ...this.request, qty: 1 });
    }

    override get orgPrice(): number | undefined {
        return this.model!.getPrice({ ...this.request, qty: 1 });
    }
}
